export default {"src":"/_next/static/media/popLeft.b0b8c80d.svg","height":255,"width":254,"blurWidth":0,"blurHeight":0};